<template>
  <div class="footer">
    <div class="copyright">
      <!--  Copyright
      <a-icon type="copyright" /> {{ new Date().getFullYear() }} <span>智慧显示(中国)&nbsp; -->
      <a href="https://beian.miit.gov.cn/#/integrated/index" target="_blank"><span>蜀ICP备19017601号-1</span></a>
      <!-- &nbsp;软件服务中心</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .copyright {
          /* color: rgba(0, 0, 0, 0.45); */
          /* font-size: 14px; */

          a {
            text-decoration: underline;
            /* color: rgba(0, 0, 0, 0.45); */

           /*  &:hover {
              color: rgba(0, 0, 0, 0.65);
            } */
          }
        }
}
</style>
